import { Switch, Match, type VoidComponent } from "solid-js";
import type { PlanStatus } from "./Plan";
import Pill from "../../../../../../components/pill/Pill";
import { useTranslation } from "../../../../../../state/i18n";

type PlanStatusPillProps = {
  status: PlanStatus;
};

const PlanStatusPill: VoidComponent<PlanStatusPillProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Switch>
      <Match when={props.status === "trial"}>
        <Pill variant="upgrade" label={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_STATUS_TRIAL)} icon="sparkles" />
      </Match>
      <Match when={props.status === "active"}>
        <Pill variant="success" label={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_STATUS_ACTIVE)} />
      </Match>
      <Match when={props.status === "pastDue"}>
        <Pill variant="warning" label={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_STATUS_PAST_DUE)} />
      </Match>
      <Match when={props.status === "unpaid"}>
        <Pill variant="danger" label={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_STATUS_UNPAID)} />
      </Match>
      <Match when={props.status === "blocked"}>
        <Pill variant="danger" label={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_STATUS_BLOCKED)} />
      </Match>
    </Switch>
  );
};

export default PlanStatusPill;
